import { createFileRoute, Link } from "@tanstack/react-router";
import { PageHero, Eyebrow, FaqList, FinalCta, faqLd } from "@/components/sections";
import { faqGroups, allFaqs } from "@/lib/site-data";
import { pageHead, breadcrumbLd } from "@/lib/seo";

const TITLE = "Mobile Mechanic FAQs | 406 Mobile Mechanic, Great Falls MT";
const DESC = "Answers about mobile auto repair in Great Falls, MT — hours, roadside help, cold-weather no-starts, fleet service, military discount and quotes.";

export const Route = createFileRoute("/faq")({
  head: () => pageHead("/faq", TITLE, DESC, [faqLd(allFaqs), breadcrumbLd([{ name: "Home", path: "/" }, { name: "FAQ", path: "/faq" }])]),
  component: FaqPage,
});

function FaqPage() {
  return (
    <main>
      <PageHero
        crumbs={[{ label: "Home", to: "/" }, { label: "FAQ" }]}
        title={<>Mobile Mechanic FAQs for <span className="text-primary">Great Falls, MT</span></>}
        intro="Straight answers to the questions people ask most. Don't see yours? Call or text 406-799-0095."
        photo="truck"
      />
      <section className="bg-background py-24">
        <div className="mx-auto max-w-4xl space-y-16 px-4 sm:px-6">
          {faqGroups.map((g) => (
            <div key={g.group}>
              <Eyebrow>{g.group}</Eyebrow>
              <h2 className="mt-4 text-4xl font-black md:text-5xl">{g.group} Questions</h2>
              <FaqList items={g.items} />
            </div>
          ))}
          <p className="text-foreground/85">Ready to book? <Link to="/contact" className="text-primary hover:underline">Send a request</Link> or <Link to="/services" className="text-primary hover:underline">browse services</Link>.</p>
        </div>
      </section>
      <FinalCta />
    </main>
  );
}
